/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {combineReducers, configureStore} from '@reduxjs/toolkit'

/**
 * Reducers
 */
import wizardReducers from "./ducks/Wizard/rootReducer";
import jamaReducer from "./ducks/Jama/jama"
import scenarioAnalysisReducer from "./ducks/ScenarioAnalysis/slice";
import coverageRequirementsReducer from "./ducks/CoverageRequirements/slice";
import userReducer from './ducks/User/slice'
import globalDialogReducer from './ducks/GlobalDialog/slice'
import globalRightClickMenuReducer from './ducks/GlobalRightClickMenu/slice'
import accessControlReducer from './ducks/AccessControl/slice'
import favoritesReducer from "./ducks/Favorites/slice";
import adasProgramsReducer from './ducks/AdasPrograms/slice'
import { reducer as sensingSystemArchitectureDesignReducer } from './ducks/SensingSystemArchitectureDesign'
import { reducer as usersReducer } from './ducks/Users'
import vehicleProgramsDetailsReducer from './ducks/VehicleProgramsDetails/slice'
import miscSlice from "./ducks/Misc/slice";

/**
 * Sagas
 */
import createSagaMiddleware from "@redux-saga/core";
import rootSaga from "./rootSaga";

const rootReducer = combineReducers({
  wizard: wizardReducers,
  jamaTime: jamaReducer,
  scenarioAnalysis: scenarioAnalysisReducer,
  coverageRequirements: coverageRequirementsReducer,
  userSlice: userReducer,
  globalDialog: globalDialogReducer,
  globalRightClickMenu: globalRightClickMenuReducer,
  accessControl: accessControlReducer,
  favorites: favoritesReducer,
  adasPrograms: adasProgramsReducer,
  sensingSystemArchitectureDesign: sensingSystemArchitectureDesignReducer,
  users: usersReducer,
  vehicleProgramsDetails: vehicleProgramsDetailsReducer,
  miscSlice: miscSlice,
})

let sagaMiddleware = createSagaMiddleware()
const middleware = [sagaMiddleware]

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
  devTools: process.env.NODE_ENV === 'development',
})

sagaMiddleware.run(rootSaga)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store